import { STAGE_STYLES, PRIORITY_STYLES, STATUS_STYLES, CUSTOMER_STATUS_STYLES, PROJECT_STATUS_STYLES, PHASE_STATUS_STYLES, SITE_VISIT_STATUS_STYLES, INVOICE_STATUS_STYLES } from "@/lib/theme";

const MAP = {
  stage: STAGE_STYLES,
  priority: PRIORITY_STYLES,
  status: STATUS_STYLES,
  customer: CUSTOMER_STATUS_STYLES,
  project: PROJECT_STATUS_STYLES,
  phase: PHASE_STATUS_STYLES,
  site_visit: SITE_VISIT_STATUS_STYLES,
  invoice: INVOICE_STATUS_STYLES,
};

export function StatusBadge({ value, type = "stage", dot = false, className = "", testid }) {
  const style = (MAP[type] && MAP[type][value]) || { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${className}`}
      style={{ backgroundColor: style.bg, color: style.text, border: `1px solid ${style.border || "transparent"}` }}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: style.dot || style.text }} />}
      {value}
    </span>
  );
}
